import { useEffect, useState } from "react";
import { Eye, MessageCircle, TrendingUp, Flame } from "lucide-react";
import { fetchBoostStats } from "@/lib/api";

export const BoostStatsPanel = ({ annonce }) => {
  const [s, setS] = useState(null);
  useEffect(() => { annonce?.id && fetchBoostStats(annonce.id).then(setS).catch(() => {}); }, [annonce?.id, annonce?.boosted_until]);
  if (!s?.has_data) return null;
  const Item = ({ icon: I, label, value, testid }) => (
    <div className="rounded-xl bg-white/70 border border-rose-100 px-2.5 py-2 text-center" data-testid={testid}>
      <I size={13} className="mx-auto text-rose-500" />
      <div className="text-base font-black leading-tight mt-0.5">{value}</div>
      <div className="text-[9px] font-semibold uppercase tracking-wide text-neutral-500">{label}</div>
    </div>
  );
  return (
    <div className="mt-2 rounded-2xl bg-gradient-to-br from-rose-50 to-orange-50 border border-rose-200 p-3" data-testid={`boost-stats-${annonce.id}`}>
      <div className="flex items-center justify-between text-[11px] font-bold text-rose-700">
        <span className="inline-flex items-center gap-1"><Flame size={12} /> Resultats du boost {s.active ? "(en cours)" : "(termine)"}</span>
        <span className="font-semibold text-neutral-500">{s.hours_elapsed} h</span>
      </div>
      <div className="mt-2 grid grid-cols-3 gap-2">
        <Item icon={Eye} label="Vues" value={s.views_gained} testid={`boost-views-${annonce.id}`} />
        <Item icon={MessageCircle} label="Contacts" value={s.contacts_gained} testid={`boost-contacts-${annonce.id}`} />
        <Item icon={TrendingUp} label="Vues en +" value={`+${s.extra_views}`} testid={`boost-extra-${annonce.id}`} />
      </div>
      <p className="mt-1.5 text-[10px] text-neutral-500">« Vues en + » = vues obtenues au-dela de votre rythme habituel ({s.views_before_daily}/jour avant le boost).</p>
    </div>
  );
};
